jQuery(document).on('nfFormReady', function (e, layoutView) {
    jQuery(
        "input[type='text'], input[type='password'], input[type='date'], input[type='datetime'], input[type='datetime-local'], input[type='month'], input[type='week'], input[type='email'], input[type='number'], input[type='search'], input[type='tel'], input[type='time'], input[type='url'], textarea"
    ).on('focus', function () {
        jQuery(this).closest('.field-wrap').addClass('field-wrap--state-focus')
    })

    jQuery(
        "input[type='text'], input[type='password'], input[type='date'], input[type='datetime'], input[type='datetime-local'], input[type='month'], input[type='week'], input[type='email'], input[type='number'], input[type='search'], input[type='tel'], input[type='time'], input[type='url'], textarea"
    ).on('blur', function () {
        var inputValue = jQuery(this).val()
        if (inputValue == '') {
            jQuery(this).removeClass('filled')
            jQuery(this).closest('.field-wrap').removeClass('field-wrap--state-focus')
        } else {
            jQuery(this).addClass('filled')
        }
    })
})

jQuery(document).ready(function ($) {
    $('.css\\3A after-load').each(function (index, element) {
        setTimeout(function () {
            $(element).removeClass('css:after-load')
        }, 10)
    })
})

const domReady = (callBack) => {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callBack)
    } else {
        callBack()
    }
}

const windowReady = (callBack) => {
    if (document.readyState === 'complete') {
        callBack()
    } else {
        window.addEventListener('load', callBack)
    }
}

// Vanilla version of jQuery's .closest for classes
const getClosest = (elem, classes) => {
    for (; elem && elem !== document; elem = elem.parentNode) {
        if (elem.classList.contains(classes)) return elem
    }
    return null
}

const getOffset = (element) => {
    let rect = element.getBoundingClientRect()

    return {
        left: rect.left + window.scrollX,
        width: rect.width,
    }
}

const shrinkNavigation = () => {
    let navigation = document.querySelector('.header--page'),
        coverBlock = document.querySelector('.block\\3A cover'),
        trigger = (coverBlock.offsetHeight / 4) * 3 - navigation.offsetHeight,
        scrollPosition = window.scrollY

    window.addEventListener('scroll', function () {
        scrollPosition = window.scrollY

        if (scrollPosition >= trigger) {
            navigation.classList.add('header--page--scrolled')
        } else if (scrollPosition <= trigger) {
            navigation.classList.remove('header--page--scrolled')
        }
    })
}

domReady(() => {
    // shrinkNavigation()
})

windowReady(() => {
    const hamburger = document.querySelector('.btn-hamburger'),
        header = document.querySelector('.header--page'),
        toggles = document.querySelectorAll('.main-menu__toggle'),
        toggleClass = 'main-menu__toggle--active',
        toggleSubClass = 'main-submenu--active'

    let isHamburgerActive = false

    hamburger.addEventListener('click', function (event) {
        console.log('hamburger')
        isHamburgerActive = !isHamburgerActive
        isHamburgerActive == true ? header.classList.add('header--active') : header.classList.remove('header--active')
        hamburger.setAttribute('aria-expanded', isHamburgerActive)

        if (isHamburgerActive == false) {
            const activeToggle = document.querySelector('.' + toggleClass),
                activeSubmenu = document.querySelector('.' + toggleSubClass)

            if (activeToggle !== null && activeSubmenu !== null) {
                toggleSlideUp(activeToggle, activeSubmenu)
            }
        }
    })

    const toggleSlideDown = (toggle, submenu) => {
        toggle.classList.add(toggleClass)
        submenu.classList.add(toggleSubClass)
        submenu.style.height = 'auto'

        var height = submenu.clientHeight + 'px'

        submenu.style.height = '0px'

        setTimeout(function () {
            submenu.style.height = height
        }, 0)
    }

    const toggleSlideUp = (toggle, submenu) => {
        toggle.classList.remove(toggleClass)
        submenu.style.height = '0px'

        submenu.addEventListener(
            'transitionend',
            function () {
                submenu.classList.remove(toggleSubClass)
            },
            {
                once: true,
            }
        )
    }

    for (const toggle of toggles) {
        toggle.addEventListener('click', function (event) {
            const activeToggle = document.querySelector('.' + toggleClass),
                activeSubmenu = document.querySelector('.' + toggleSubClass),
                toggleSibling = toggle.nextElementSibling

            if (activeToggle !== null && activeSubmenu !== null) {
                toggleSlideUp(activeToggle, activeSubmenu)
            }

            if (!toggleSibling.classList.contains(toggleSubClass)) {
                toggleSlideDown(toggle, toggleSibling)
            } else {
                toggleSlideUp(toggle, toggleSibling)
            }
        })
    }

    const toggleTooltip = (element) => {
        activeTooltip = element
        activeTooltip.classList.toggle('tooltip--active')
    }

    const tooltipTriggers = document.querySelectorAll('.search-result__btn')
    let activeTooltip = false

    for (const tooltipTrigger of tooltipTriggers) {
        tooltipTrigger.addEventListener('click', function (event) {

                let tooltip = this.nextElementSibling

                if (activeTooltip != false) {
                    if (activeTooltip != tooltip) {
                        activeTooltip.classList.remove('tooltip--active')
                        activeTooltip = false
                    }
                }
                toggleTooltip(tooltip)

        })
    }
})

jQuery(document).ready(function ($) {
    $('.block\\3A dynamic__carousel').each(function () {
        var controls = $(this).parent().find('.controls')
        $(this).slick({
            dots: false,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: false,
            appendArrows: $(controls),
            nextArrow: $(controls).find('.controls__button--next'),
            prevArrow: $(controls).find('.controls__button--prev'),
        })
    })




})

jQuery(window).on('load', function () {
    const lightbox = GLightbox({
        selector: '.block\\3A gallery__item',
        loop: true,
        autoplayVideos: true,
    })

    const signUpButton = document.getElementById('signUp')
    const signInButton = document.getElementById('signIn')
    const container = document.getElementById('customer_login')

    if (typeof signUpButton != 'undefined' && signUpButton != null) {
        signUpButton.addEventListener('click', () => {
            container.classList.toggle('right-panel-active')
        })

        signInButton.addEventListener('click', () => {
            container.classList.toggle('right-panel-active')
        })
    }
})

const modals = document.querySelectorAll("[data-modal]");

modals.forEach(function (trigger) {
  trigger.addEventListener("click", function (event) {
    event.preventDefault();
    const modal = document.getElementById(trigger.dataset.modal);
    modal.classList.add("open");
    document.body.classList.add("has-modal");
    const exits = modal.querySelectorAll(".modal-exit");
    exits.forEach(function (exit) {
      exit.addEventListener("click", function (event) {
        event.preventDefault();
        modal.classList.remove("open");
        document.body.classList.remove("has-modal");
      });
    });
  });
});
